"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsCard = void 0;
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_i18next_1 = require("react-i18next");
const className_1 = require("../../utils/className");
exports.SmlsCard = (_a) => {
    var { id, label = '', icon, isHorizontal, className = '', revenue, onClick } = _a, params = __rest(_a, ["id", "label", "icon", "isHorizontal", "className", "revenue", "onClick"]);
    const { t } = react_i18next_1.useTranslation();
    if (revenue && className.split(' ').includes('extraRevenue')) {
        return (react_1.default.createElement(reactstrap_1.Card, { id: id, className: className_1.mapToCssModules([className]), onClick: onClick, tabIndex: -1 },
            react_1.default.createElement(reactstrap_1.CardBody, { className: `${className}` },
                react_1.default.createElement("div", { className: "card-icon" },
                    react_1.default.createElement("img", { src: revenue.icons.product.url, alt: revenue.icons.product.text })),
                react_1.default.createElement("h5", { className: "card-title" }, revenue.title),
                react_1.default.createElement("div", { className: "card-content" },
                    revenue.lines.first && (react_1.default.createElement("span", { className: "line-first", dangerouslySetInnerHTML: {
                            __html: revenue.lines.first,
                        } })),
                    revenue.failover && (react_1.default.createElement("span", { className: "line-second", dangerouslySetInnerHTML: {
                            __html: revenue.failover,
                        } })),
                    !revenue.failover && (react_1.default.createElement(react_1.default.Fragment, null,
                        revenue.productOffer === 'acumulo' ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("span", { className: "line-third", dangerouslySetInnerHTML: {
                                    __html: revenue.lines.third,
                                } }),
                            react_1.default.createElement("span", { className: "line-second" }, revenue.lines.second))) : (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("span", { className: "line-second" }, revenue.lines.second),
                            react_1.default.createElement("span", { className: "line-third", dangerouslySetInnerHTML: {
                                    __html: revenue.lines.third,
                                } }))),
                        revenue.lines.fourth && (react_1.default.createElement("div", { className: "line-fourth", dangerouslySetInnerHTML: {
                                __html: revenue.icons.reward + revenue.lines.fourth,
                            } }))))))));
    }
    return (react_1.default.createElement(reactstrap_1.Card, Object.assign({ id: id, className: className_1.mapToCssModules([isHorizontal ? 'horizontal' : '', className]), onClick: onClick }, params),
        react_1.default.createElement(reactstrap_1.CardHeader, { className: `${className}` }, isHorizontal ? (react_1.default.createElement("span", null, icon)) : (react_1.default.createElement("i", { className: "material-icons" }, icon))),
        react_1.default.createElement(reactstrap_1.CardBody, { className: `${className}` },
            react_1.default.createElement("p", { className: "card-text" }, t(label)))));
};
//# sourceMappingURL=index.js.map